export const orderDateOptions = [
  "4months",
  "3months",
  "2months",
  "1month",
  "7days",
  "yesterday",
  "today",
] as const;

export type OrderDateOption = (typeof orderDateOptions)[number];
